<template>
  <nav class="navigation" :style="{display: isMobile && !showMenu ? 'none' : 'flex'}">
    <div class="navigation__container">
      <div class="navigation__links">
        <router-link
          tag="div"
          class="navigation__link"
          to="/"
          :class="{active: getTourList().find(tour => `/${tour.id}` === $route.path)}"
          @click.native="$emit('close')"
        >Weinreisen</router-link>
        <router-link
          tag="div"
          v-for="tour in getTourList()"
          :key="tour.id"
          class="navigation__link child"
          :to="tour.id"
          @click.native="$emit('close')"
        >{{tour.title}}</router-link>
        <router-link
          tag="div"
          class="navigation__link about"
          to="/about"
          @click.native="$emit('close')"
        >Über mich</router-link>
      </div>

      <div class="navigation__infos-mobile">
        <div class="navigation__info-mobile">
          <icon name="phone"></icon>
          <div>0176 / 834 915 08</div>
        </div>
        <div class="navigation__info-mobile">
          <icon name="mail"></icon>
          <a
            class="navigation__mail"
            href="mailto:info@auszeit-weinreisen.de"
          >info@auszeit-weinreisen.de</a>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
import Icon from "../icon/Icon";

export default {
  name: "Navigation",
  data() {
    return {
      isMobile: false,
      active: 0
    };
  },
  props: {
    showMenu: Boolean
  },
  computed: {
    routes: function() {
      var routes = [];
      for (var i in this.$router.options.routes) {
        if (!this.$router.options.routes.hasOwnProperty(i)) {
          continue;
        }
        var route = this.$router.options.routes[i];
        if (route.hasOwnProperty("title")) {
          routes.push(route);
        }
      }
      return routes;
    }
  },
  methods: {
    onResize() {
      this.isMobile = window.innerWidth < 768;
      if (!this.isMobile) this.$emit("close");
    }
  },
  beforeDestroy() {
    if (typeof window !== "undefined") {
      window.removeEventListener("resize", this.onResize, { passive: true });
    }
  },
  watch: {
    showMenu(value) {
      if (value) {
        //document.documentElement.classList.add("no-scroll");
        //document.body.classList.add("no-scroll");
      } else {
        //document.documentElement.classList.remove("no-scroll");
        //document.body.classList.remove("no-scroll");
      }
    }
  },
  mounted() {
    this.onResize();
    window.addEventListener("resize", this.onResize, { passive: true });
  },
  components: {
    Icon
  }
};
</script>

<style scoped lang="scss">
.navigation {
}

.navigation__container {
}

.navigation__links {
  margin: 0 28px;
  display: flex;
  flex-direction: row;
}

.navigation__link {
  //font-family: SoleilSb;
  font-family: Lato;
  font-weight: 700;
  font-size: 18px;
  letter-spacing: 0.5px;
  color: #999999;
  margin: 12px;
  cursor: pointer;
  position: relative;
  text-decoration: none;

  &:hover {
    &::after {
      content: "";
      width: 32px;
      height: 2px;
      background: #999999;
      position: absolute;
      left: 0;
      bottom: -2px;
    }
  }

  &.router-link-exact-active,
  &.active {
    color: #0d0d0d;

    &::after {
      content: "";
      width: 32px;
      height: 2px;
      background: #0d0d0d;
      position: absolute;
      left: 0;
      bottom: -2px;
    }
  }

  &.child {
    display: none;
    margin: 0 0 24px 16px;
  }
}

.navigation__infos-mobile {
  margin-top: 16px;
  display: none;
}

.navigation__info-mobile {
  height: 64px;
  border-radius: 4px;
  border: solid 2px #0d0d0d;
  flex-direction: row;
  align-items: center;
  margin: 0 0 24px;
  width: 100%;
  padding: 20px 24px;
  color: #0d0d0d;
  line-height: 23px;
  //font-family: SoleilLt;
  font-family: Lato;
  font-weight: 300;
  font-size: 18px;
  letter-spacing: 0.23px;
  color: #0d0d0d;
  display: flex;

  .icon {
    margin-right: 16px;
  }
}

.navigation__mail {
  text-decoration: none;
  color: #0d0d0d;
}

@media (max-width: 1023px) {
  .navigation__links {
    margin: 0 12px;
  }
}

@media (max-width: 767px) {
  .navigation {
    position: fixed;
    left: 0;
    top: 64px;
    right: 0;
    height: calc(100vh - 64px);
    margin: 0;
    background: #ffffff;
    z-index: 100;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .navigation__container {
    padding: 24px;
    overflow-y: auto;
  }

  .navigation__links {
    margin: 0;
    flex-direction: column;
  }

  .navigation__link {
    text-align: left;
    display: block;
    margin: 0 0 24px;

    &.child {
      display: block;
    }

    &.about {
      padding-top: 8px;
    }
  }

  .navigation__infos-mobile {
    display: block;
  }
}
</style>
